import { useCallback, useEffect, useState } from "react";
import { StringNumber, TCelula } from "../../../../types";
import api from "../../../../utils/api";
import { useParams } from "react-router-dom";
import { useErrorSuccess } from "../../../../hooks/useErrorSuccess";
import useNav from "../../../../hooks/useNav";

export type ResponseServiceEdit = {
  celulaSelecionada: TCelula|undefined;
  updateCelula: VoidFunction;
  getCelula: Function;
  changeCampusCelula: (campo: string, valor: StringNumber | null) => void;
};

export const Services = (): ResponseServiceEdit => {
  const [celulaSelecionada, setCelulaSelecionada] = useState<TCelula>();

  const { id } = useParams();
  const { setErrorSuccess } = useErrorSuccess();
  const { goBack } = useNav()

  const getCelula = useCallback(async () => {
    try {
      const req = await api.get("/ministerio/celula/"+id);
      const res = req.data;

      setCelulaSelecionada(res);
    } catch (error) {

    }
  }, []);

  const updateCelula = async () => {
    try {
      const req = await api.put('ministerio/celula/'+id, {...celulaSelecionada, ministerio: celulaSelecionada.ministerio.id});
      const res = req?.data;

      setErrorSuccess({ mensagem: 'Celula Atualizada', status: 'success' });

      goBack();
    } catch(error) {
      setErrorSuccess({ mensagem: 'error', status: 'error' })
    }
  };

  const changeCampusCelula = (campo: string, value: StringNumber | null) => {

    setCelulaSelecionada(
      (valor: any) => {

      const isChildrenField = campo?.split('.')?.length > 1

      if(isChildrenField) {
        const val = campo?.split('.')?.reduce(
          (prev, current) => prev?.[current], valor
        );

        return { ...valor, [campo]: value }
      }

      return { ...valor, [campo]: value }
    }
  )

  }


  useEffect(() => {
    getCelula();
  }, [])

  return {
    celulaSelecionada,
    updateCelula,
    getCelula,
    changeCampusCelula
  }
};
